module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_3-218674f9f642db82cd0ba7724b0aff4e.jpg";